import React from 'react';
import OptimizedRouteDetail from "app/deliveryTool/pages/itineraire/OptimizedRouteDetail";

const OptimizedRoutesList = ({ routes, onRoadmapSaved }) => {
  return (
    <div>
      {routes && routes.map((route, index) => (
        <div key={index}>
          <OptimizedRouteDetail 
            key={index} 
            roadmap={route} 
            onRoadmapSaved={onRoadmapSaved}
          />
        </div>
      ))}
    </div>
  );
};

export default OptimizedRoutesList; 